/* eslint-disable */
export default {
    init() {
        const backToTop = document.querySelector('.scroll-to--to-top');
        const backgrounds = document.querySelectorAll('[data-bg]');
        
        const onScroll = (e) => {
            if (backToTop && backgrounds.length > 0) {

                backgrounds.forEach(element => {
                    const elRect = element.getBoundingClientRect();
                    const top = elRect.top;
                    const bottom = elRect.bottom;
                    const bckRect = backToTop.getBoundingClientRect();
                    const bckTop = bckRect.top;
                    const bckBottom = bckRect.bottom;

                    if(bckTop > top && bckTop < bottom) {
                        backToTop.classList.add('on-dark-bg');
                    } else {
                        backToTop.classList.remove('on-dark-bg');
                    }

                })
            }
        }

        window.addEventListener("scroll", onScroll);
    }
}

